import i18next from 'i18next';

export const getPanelsOptions = (panels) => {
    const items = panels.map((item) => ({ label: item.name, value: item.id }));
    return [
        { disabled: true, label: i18next.t('Select'), value: '' },
        ...items,
    ];
};

export const getPanelBrandsOptions = (brands) => {
    const items = brands.map((item) => ({
        label: item.name,
        value: item.name,
    }));
    return [
        { disabled: true, label: i18next.t('Select'), value: '' },
        ...items,
    ];
};

export const getRoofTypesOptions = (types) => {
    const items = types.map((item) => ({ label: item.name, value: item.key }));

    return [
        { disabled: true, label: i18next.t('Select'), value: '' },
        ...items,
    ];
};

export const getSystemTypesOptions = (types) => {
    const items = types.map((item) => ({ label: item.name, value: item.id }));
    return [
        { disabled: true, label: i18next.t('Select'), value: '' },
        ...items,
    ];
};
